import {call, put} from 'redux-saga/effects';
import UserProfileActions from '../redux/UserProfileRedux';
import { mergeDeep } from '../helpers/object';
import MessagesActions from '../redux/MessagesRedux';

export function * getUserProfile(api, action) {
  const response = yield call(api.getUserProfile);

  if (response.ok) {
    yield put(UserProfileActions.userProfileSuccess(transformUserData(response.data)));
  } else {
    yield put(UserProfileActions.userProfileFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

const transformUserData = data => {
  if (data 
    && data.userRole 
    && data.userRole.functions 
    && data.userRole.functions.length) {
    let profile = {...data};
    let permissions = {};
    data.userRole.functions.forEach(keyString => {
      let obj = {};
      let target = obj;
      const value = true;
      const keys = keyString.split('.');
      keys.forEach((key, index) => {
        target = target[key] = index === keys.length - 1 ? value : {};
      });
      target = value;
      permissions = mergeDeep(permissions, obj);
    })
    profile.permissions = permissions;
    return profile;
  }
  return data;
}

const USER_PERMISSIONS = {
  clients: {
    view: true
  },
  client: {
    create: true,
    info: {
      view: true,
      edit: true,
    },
    passport: {
      view: true,
      edit: true,
    },
    note: {
      view: true,
      edit: true,
    },
    car: {
      add: true,
      info: {
        view: true,
      },
      system: {
        view: true,
        edit: true,
      },
      errors: {
        view: true,
        reset: true,
        archive: {
          view: true,
        }
      },
      agents: {
        view: true,
        edit: true,
      }
    }
  },
  mailings: {
    view: true
  },
  mailing: {
    view: true,
    edit: true,
    create: true,
    delete: true,
  },
  reports: {
    view: true
  },
  report: {
    view: true,
    edit: true,
    create: true,
    delete: true,
  },
  dealers: {
    view: true
  },
  dealer: {
    create: true,
    view: true,
    edit: true,
    delete: true,
  },
  users: {
    view: true
  },
  user: {
    create: true,
    view: true,
    edit: true,
    delete: true,
  }
}